import React from 'react'
import { translate } from 'react-i18next'
import { compose, pure } from 'recompose'
import Modal from 'react-modal'
import styles from './modalWrapperComponent.scss'
import PropTypes from 'prop-types'
import IconCloseModal from '../../assets/icons/iconCloseModal.svg'

export function ModalWrapper (props) {
  // const { t } = props
  return (
    <Modal
      className={{
        base: styles.modal,
        afterOpen: styles.modalOpen,
        beforeClose: styles.modalClosing
      }}
      overlayClassName={{
        base: styles.modalOverlay,
        afterOpen: styles.modalOverlayAfterOpen,
        beforeClose: styles.modalOverlayBeforeClose
      }}
      {...props}
    >
      <button
        type='button'
        aria-label='Close'
        className={styles.closeButton}
        onClick={props.onRequestClose}
      >
        <IconCloseModal />
      </button>
      {props.children}
    </Modal>
  )
}

ModalWrapper.propTypes = {
  onRequestClose: PropTypes.func.isRequired,
  children: PropTypes.any
}

export default compose(pure, translate())(ModalWrapper)



// WEBPACK FOOTER //
// ./src/components/modalWrapper/modalWrapperComponent.js